
import ClientHead from "@/components/main/core/ClientHead";

import RedSection from "@/components/main/core/RedSection";


import GreySection from "@/components/main/core/GreySection";

import BoxPhoto from "@/components/main/core/BoxPhoto";

import CheckBox from "@/components/main/core/CheckBox";
import MainButton from "@/components/main/buttons/MainButton";

import featured from "@/mixins/data"


import beautiful from "@/assets/images/e-book/beautiful.png"

import keephimhot from "@/assets/images/e-book/keephimhot.png"
import lookbefore from "@/assets/images/e-book/lookbefore.png"
import mating from "@/assets/images/e-book/mating.png"
import overcoming from "@/assets/images/e-book/overcoming.png"
import WhatDouYoWant from "@/assets/images/e-book/whatdoyouwant.png"

export default {
  name: "ebook",
  layout: 'clientLayout',
  head() {
    const title = 'Free Relationship eBooks - Insights on Relationships, Love & Cheating | iFindCheaters';
    const description = 'Dive into insightful eBooks on relationships, dating, passionate love, how to deal with cheating. and overcoming infidelity. Explore our ebooks - Look Before You Leap,Keeping It Hot, Overcoming Infidelity, and more. Empower your love life with knowledge from iFindCheaters.';

    return {
      title: title,
      meta: [
      {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Free eBooks on Love, Free eBooks on Cheating, Free eBooks on Relationship, how to deal with cheating, Look Up Cheaters Online, Cheating Online, Catch a Cheating Partner Online, websites for catching cheaters, Best Cheater Lookup Websites, catch cheating spouse'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/ebook/",
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "eBook about Relationships and Love",
            }],
          }
        }
      ]
    };
  },

  mixins: [featured],
  components: { ClientHead, MainButton, RedSection, GreySection, BoxPhoto, CheckBox,  },
  data() {
    return {

      books: [
        {
          title: 'look before you leap',
          mainText: 'Learn the subtle and not so subtle differences between ‘dating’ and ‘relationship’ status. This guide gives you tips to navigate the new. It also offers hints at when it’s the right time to take things to the next level.',
          list1: '“I love you…” say it when you mean it.',
          list2: 'Private vs public surprises.',
          list3: 'Dos and don’ts of public displays of affection.',
          list4: 'Talk about sex before and after.',
          img: lookbefore,
        },
        {
          title: 'keeping it hot',
          mainText: 'Passion fuels fidelity. Happiness is an active state so invest in it! Keep your relationship sizzling. This guide offers tips to keep the home fires burning. Seduce your partner everyday and you’ll be sure they never stray!',
          list1: 'Play together to stay together.',
          list2: 'Lust, Orgasms, Variety, Ecstasy',
          list3: 'Flirt shamelessly at home.',
          list4: 'The de-stress striptease.',
          img: keephimhot,
        },
        {
          title: 'overcoming infidelity',
          mainText: 'If you have had your heart broken it can be hard to trust again. Learn how to take stock of the situation and decide if your relationship is worth fighting for. If you are moving on learn how to protect yourself in future.',
          list1: 'Know when to level-up or cut your losses.',
          list2: 'Learn from experience.',
          list3: 'Read the warning signs.',
          list4: 'Invest in happiness.',
          img: overcoming,
        },
        {
          title: 'what do you really want',
          mainText: 'Popular media bombards us with ‘ideal’ relationship models. Reality check: what makes you happy and connects you and your partner may be nothing like those ‘ideals’. Focus on what you really want, it will come.',
          list1: 'Decide when sex is on the table.',
          list2: 'Face fears and define desires.',
          list3: 'Admit you don’t know so you can learn.',
          list4: 'Needs don’t mean you are needy.',
          img: WhatDouYoWant,
        },

        {
          title: 'Beautiful Daring Sensual Mayhem',
          mainText: 'The Fifty Shades of Grey franchise has blown up curiosity surrounding the BDSM lifestyle. Learn how you can incorporate the fun of role play and toys and blow up you and your partner’s sex life too!',
          list1: 'What is kinky to you.',
          list2: 'Being safe and sane and acknowledging consent.',
          list3: 'Touch yourself before you touch others.',
          list4: 'The 411 on foreplay and aftercare.',
          img: beautiful,
        },

        {
          title: 'mating in captivity',
          mainText: 'The Devil is in the details, so is desire! It is not grand gestures but the little things you do for and say to your partner that keep you always on their mind. Small actions have super impact on keeping your love alive.',
          list1: 'Talk about what turns you on and off',
          list2: 'Snuggle and Cuddle Often',
          list3: 'Make Sex a Priority',
          list4: 'Romantic Escapes',
          img: mating,
        },

      ]
    }
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
